var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-search',{attrs:{"placeholder":_vm.placeholder,"use-left-icon-slot":true,"value":_vm.value},on:{"input":value => _vm.$emit('input', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }